import styles from './styles.module.scss';
import clsx from 'clsx';
import { FC } from 'react';

export const WipRegCell: FC<{ wipNo?: number; regNo?: string }> = ({ wipNo, regNo }) => {
  return (
    <div>
      <div className={styles.textBold}>{wipNo}</div>
      <div className={clsx(styles.regNo, styles.textBold)}>{regNo}</div>
    </div>
  );
};
